var _excluded = ["children", "href", "element", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { node, string, func, oneOfType, object } from 'prop-types';
import classNames from 'classnames';
import TextLink from '../../TextLink/TextLink';
var propTypes = {
  /** The contents of the list group item */
  children: node.isRequired,

  /** If you want it to be a regular link. This will generate an `a` element. */
  href: string,

  /** The type of element you need. `a` or `Link` (from react router) are the most common.
   *
   * Example usage with React Router:<br>
   * `<ListGroupItem element={Link} to="/somepage" />` */
  element: oneOfType([string, func, object])
};
/** The ListGroupItem is a child of the ListGroup component
 * @visibleName List Group Item
 * */

var ListGroupItem = function ListGroupItem(_ref) {
  var children = _ref.children,
      href = _ref.href,
      element = _ref.element,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = classNames('rds-list-group__item', className);

  if (element) {
    return /*#__PURE__*/React.createElement("li", {
      className: componentClassNames
    }, /*#__PURE__*/React.createElement(TextLink, _extends({
      element: element,
      className: "rds-list-group__link",
      href: href
    }, rest), children));
  } else if (href) {
    return /*#__PURE__*/React.createElement("li", {
      className: componentClassNames
    }, /*#__PURE__*/React.createElement("a", _extends({
      element: element,
      className: "rds-list-group__link rds-link",
      href: href
    }, rest), children));
  } else {
    return /*#__PURE__*/React.createElement("li", _extends({
      className: componentClassNames
    }, rest), children);
  }
};

ListGroupItem.propTypes = propTypes;
export default ListGroupItem;